const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://5ti7hsqlgl.execute-api.us-west-2.amazonaws.com/prod',
    TARGET_API_URL: 'https://8tj4etljfj.execute-api.us-west-2.amazonaws.com/api',
    TEAMS_APP_URL: 'https://teams.dev.apps.forwoodsafety.com/teams',
    QS_DASHBOARD_URL: '',
    CLIENT_TIMEZONE: 'America/Sao_Paulo'
  },
  reactApp: {
    VERSION: 'targets-1.11.0',
    HOSTNAME: 'https://targets.dev.apps.forwoodsafety.com'
  }
};

export default config;